export const librarianBookRecommendation = `I want you to act as a librarian. 
I will provide you with a text snippet describing a wide range of atmospheres. 
I want you to recommend books that match the text snippet. 
You must provide me with a numbered list of 10 books in the {genre} and their author and only the list in the formate of 'number. title by author', with no duplicates.

Here is the text snippet: {imageCaption} + {textPrompt}`;
